module.exports = __webpack_public_path__ + "img/MN.13adad9a.png";